"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inject = void 0;

var _styledComponents = require("styled-components");

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    border-radius: ", ";\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        display: block;\n\n        ", "\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        display: inline-block;\n\n        ", ";\n        ", ";\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    width: ", ";\n    height: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    width: ", ";\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        height: 0.75rem;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    height: ", "rem;\n    margin: calc((", "rem * 0.375 - 1px) / 2) 0;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _textLikeStyle = function _textLikeStyle(fontSize) {
  return (0, _styledComponents.css)(_templateObject(), fontSize / 16, fontSize / 16);
};

var _getTextStyle = function _getTextStyle() {
  var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'body';

  switch (height) {
    case 'code':
    case 'small':
    case 'span':
      return _textLikeStyle(12);

    case 'article':
      return _textLikeStyle(14);

    case 'caption':
      return (0, _styledComponents.css)(_templateObject2());

    case 'h5':
      return _textLikeStyle(20);

    case 'h4':
      return _textLikeStyle(22);

    case 'h3':
      return _textLikeStyle(24);

    case 'h2':
      return _textLikeStyle(32);

    case 'h1':
      return _textLikeStyle(46);

    case 'body':
    case 'h6':
    default:
      return _textLikeStyle(16);
  }
};

var _textWidth = function _textWidth() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
  return (0, _styledComponents.css)(_templateObject3(), width);
};

var _blockSize = function _blockSize(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '2rem' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '2rem' : _ref$height;
  return (0, _styledComponents.css)(_templateObject4(), width, height);
};

var getVariant = function getVariant(_ref2) {
  var variant = _ref2.variant,
      appearance = _ref2.appearance;

  switch (variant) {
    case 'text':
      return (0, _styledComponents.css)(_templateObject5(), _textWidth(appearance === null || appearance === void 0 ? void 0 : appearance.width), _getTextStyle(appearance === null || appearance === void 0 ? void 0 : appearance.height));

    case 'block':
    default:
      return (0, _styledComponents.css)(_templateObject6(), _blockSize(appearance));
  }
};

var borderRadius = function borderRadius() {
  var borderRadius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'var(--border-radius)';
  return (0, _styledComponents.css)(_templateObject7(), borderRadius);
};

var inject = {
  getVariant: getVariant,
  borderRadius: borderRadius
};
exports.inject = inject;